module.exports = __webpack_public_path__ + "img/needle-image.614b208f.png";